import { t } from "../strings";

/** /help — auto-save trade-off (§7.4.1), lost wallet (§15.5.1), glitch policy (§11.7), fees (§15.5.3). */
export function Help() {
  return (
    <main className="page help">
      <h1>Help</h1>

      <section id="autosave">
        <h2>Auto-save</h2>
        <p>
          Pokémon Red and Blue keep defeated trainers, picked-up items and story progress only in the save file. If money reached the chain without saving
          the rest of the game, you could beat a trainer or sell a Nugget, reset, and do it again forever. So whenever your money changes, you pick up a rare
          item, or you get a new Pokémon, RedChain saves your whole game the moment you're back in control on the map — exactly as if you had used START →
          SAVE yourself.
        </p>
        <p>
          The game itself never shows anything; the panel beside the screen says "Auto-saved" for two seconds. Shopping trips and battles become one
          auto-save once you're back on the map, and auto-saves are at least 15 seconds apart.
        </p>
        <h3>What this changes</h3>
        <ul>
          <li>Resetting still works, but it can't undo something an auto-save already caught: a blackout, a purchase, a trainer battle, a rare item or a catch.</li>
          <li>Resetting to retry a wild encounter that ended without a catch still works.</li>
          <li>
            <strong>You can't soft-reset for better DVs.</strong> A starter, gift or legendary is saved as soon as you're back in control after receiving it.
            Every Pokémon's DVs are the first ones the game rolled, which keeps rare DVs meaningful.
          </li>
          <li>Moving Pokémon between your party, the PC and the Day Care doesn't trigger an auto-save; releases sync at your next save of any kind.</li>
          <li>Offline, auto-saves still happen and upload when you reconnect.</li>
        </ul>
      </section>

      <section id="wallet">
        <h2>Your wallet</h2>
        <p>
          If you log in with email, Google, Apple or Discord, a self-custodial game wallet is created for you. You can export its private key from your
          profile and use it in Phantom or any Solana wallet. RedChain never holds your key and isn't a signer on your wallet; saves are signed by the game,
          and your wallet only signs what you do yourself.
        </p>
        <h3>Lost wallet</h3>
        <p>{t.lostWallet}</p>
        <p>If you lose access to your email or social login, use that provider's account recovery. Losing both your login and any exported key loses the assets.</p>
      </section>

      <section id="glitches">
        <h2>Glitches</h2>
        <p>
          Glitches are allowed, but what they produce is never minted or credited. Item duplication, glitch Pokémon (MissingNo, the Mew glitch, the Ditto
          glitch) and arbitrary code execution give you nothing on chain.
        </p>
        <p>{t.glitch}</p>
        <p>
          Arbitrary code execution taints the whole game: from then on, nothing more is minted or credited for that playthrough (spending still counts). You
          can start a new game from your profile.
        </p>
      </section>

      <section id="fees">
        <h2>Fees and SOL</h2>
        <p>
          Network fees are paid in ₽ from your in-game money: by default ₽100 per save, ₽10 per auto-save and ₽200 per new Pokémon. They show as slightly less
          ₽ at your next load. If you don't have enough yet (before the Boulder Badge, for example), they're taken from your next winnings.
        </p>
        <p>
          Every on-chain account needs a refundable SOL deposit. Your vault pays it for each new Pokémon and for your first rare item. If the vault runs short,
          your save still goes through and the Pokémon waits to mint until you add SOL. You get the deposit back when a Pokémon is released or burned (minus a
          small amount kept by the burned account's tombstone).
        </p>
        <p>Wallet actions (claims, deposits, transfers, burns) cost ₽100 from your in-game balance, or can be paid in SOL.</p>
      </section>

      <section id="support">
        <h2>Support</h2>
        <p>If a save couldn't be verified, your last verified save is kept and loads next time. Contact support with the time of the save.</p>
      </section>
    </main>
  );
}
